import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeader } from "./Services";
import { photoUrl, isVideo } from "@/lib/api";

export default function Broadcasting({ content, photos = [], whatsapp }) {
  const b = content?.broadcasting || {};
  const preferred = ["pantalla-01.jpg", "evento-recital-02.jpg", "lacasa-01.jpg", "rack-vivo-01.jpg"];
  let photo = null;
  for (const f of preferred) { photo = photos.find((p) => p.filename === f); if (photo) break; }

  return (
    <section id="broadcasting" className="relative py-24 sm:py-28 px-5 sm:px-8 lg:px-12 bg-surface border-y border-line-2">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <SectionHeader eyebrow="Broadcasting profesional" title={b.title || "Cuando la señal no puede cortarse."} sub={b.body} />
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-px bg-line-2 border border-line-2">
              {(b.specs || []).map((s, i) => (
                <motion.div key={i} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i*0.06 }}
                  className="bg-base p-4">
                  <div className="text-fg text-[26px] font-semibold leading-none">{s.value}</div>
                  <div className="text-mute text-[11px] tracking-wider uppercase mt-2 leading-snug">{s.label}</div>
                </motion.div>
              ))}
            </div>
            <a href={`https://wa.me/${whatsapp || "5491166861309"}?text=${encodeURIComponent("Hola LUVA, quería hablar de un proyecto de broadcasting.")}`} target="_blank" rel="noreferrer" className="btn-solid mt-8 inline-flex items-center gap-2 px-5 py-3 text-[13px] rounded-sm">
              Hablar con el equipo de broadcast <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>
          <div className="lg:col-span-6 order-1 lg:order-2">
            {photo && (
              <div className="img-hover relative">
                {isVideo(photo)
                  ? <video src={photoUrl(photo)} autoPlay muted loop playsInline className="w-full aspect-[5/4] object-cover" />
                  : <img src={photoUrl(photo)} alt="" className="w-full aspect-[5/4] object-cover" />}
                <div className="brand-stripe" style={{ width: "35%", top: "15%", right: "-8%", left: "auto" }} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
